module.exports = __webpack_public_path__ + "static/img/u75.bd7d8198.png";